import { render, staticRenderFns } from "./AxArtboardUploadsPicker.vue?vue&type=template&id=5cb03464&"
import script from "./AxArtboardUploadsPicker.vue?vue&type=script&lang=ts&"
export * from "./AxArtboardUploadsPicker.vue?vue&type=script&lang=ts&"
import style0 from "./AxArtboardUploadsPicker.vue?vue&type=style&index=0&id=5cb03464&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports